import { SimplePersistenceService } from '@fkui/logic/lib/services/PersistenceService/SimplePersistenceService.js';
import { Ansokan } from '@/services/AnsokanService';

export const fmiPersistenceService = new SimplePersistenceService<Ansokan>('fmi-intyg-bestall');
